import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { Location } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { OldUiAmplitudeService } from '@shared/services/shared/amplitude/old-ui-amplitude.service';
import { UserService } from '@core/services/user.service';
import { environment } from '@environments/environment';
import { isNil } from 'lodash';

@Component({
  selector: 'ui-renta-old-ui-warning',
  templateUrl: 'old-ui-warning.component.html',
  styleUrl: 'old-ui-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MatButton,
    MatIcon,
    TranslatePipe,
  ],
})
export default class OldUiWarningComponent {
  private readonly amplitudeService = inject(OldUiAmplitudeService);
  private readonly userService = inject(UserService);
  private readonly location = inject(Location);

  protected async goToOldUi(): Promise<void> {
    const redirectUrl = this.getRedirectUrl();

    await this.amplitudeService.trackOldUIVisit();
    window.location.href = redirectUrl;
  }

  protected cancel(): void {
    this.location.back();
  }

  private getRedirectUrl(): string {
    const legacyUrl = environment.legacyUiUrl!;
    const userLoginString = this.userService.getCurrentUser()?.loginString;

    if (!isNil(userLoginString)) {
      return `${legacyUrl}&belnumber=${userLoginString}`;
    }
    return legacyUrl;
  }
}
